angular.module('qkr').controller('PasswordResetController', ($scope, $http, $window, appConfig, utils, FormHelper, messageService, gettextCatalog) => {

    $scope.form = {
        password: {
            new: '', confirm: ''
        }
    };
    $scope.errors = {};
    let formHelper = new FormHelper($scope),
        pwdRegexp = new RegExp('^.{8,}$', 'i'),
        pwdFormat = 'Password should contain at least 8 characters.',
        code;

    let validate = function(newPwd, pwdConfirmation) {
        const errors = {};

        if (utils.hasNoValue(newPwd))
            errors.newPassword = gettextCatalog.getString('Please provide the new password');

        if (utils.hasNoValue(pwdConfirmation))
            errors.passwordConfirmation = gettextCatalog.getString('Please confirm the new password');

        if (newPwd && pwdConfirmation && (newPwd != pwdConfirmation))
            errors.passwordConfirmation = gettextCatalog.getString('Passwords do not match');

        if (!pwdRegexp.test(newPwd))
            errors.newPassword = pwdFormat;

        if (!pwdRegexp.test(pwdConfirmation))
            errors.passwordConfirmation = pwdFormat;

        if (!(/[A-z]/.test(newPwd))) {
            errors.newPassword = gettextCatalog.getString('Passwords must include a letter');
        }

        if (!(/\d/.test(newPwd))) {
            errors.newPassword = gettextCatalog.getString('Passwords must include a number');
        }

        if ((/(.)(\1){2,}/.test(newPwd))) {
            errors.newPassword = gettextCatalog.getString('Passwords can\'t contain any character more than 3 time in succession.');
        }

        if (!(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(newPwd))) {
            errors.newPassword = gettextCatalog.getString('Passwords must include a special character');
        }

        $scope.errors = errors;
        return utils.isEmpty(errors);
    },

    responder = function(response) {
        const r = formHelper.handleResponse(response);
        if (r.isSuccess()) {
            messageService.success(gettextCatalog.getString('Password changed successfully.'));
            window.setTimeout(() => {
 $window.location.href = appConfig.contextPath;
}, 4000);
        } else {
            switch (r.statusCode()) {
                case 400:
                    messageService.errorWithReason(response.data.errors[0].reason, response.data.errors[0].field, true);
                    $scope.saving = false;
                    break;
                case 404:
                    messageService.errorWithReason(gettextCatalog.getString('Your password reset token is invalid. Please request for your password to be reset again.'), '404', true);
                    window.setTimeout(() => {
 $window.location.href = appConfig.contextPath;
}, 4000);
                    break;
                default:
                    messageService.errorWithReason(gettextCatalog.getString('We were unable to process your request. Please try again.'), 'unknown', true);
                    $scope.saving = false;
            }
        } 
};

    $scope.init = function(c) {
        this.code = c;
    };

    $scope.resetPassword = function() {
        if (validate($scope.form.password.new, $scope.form.password.confirm)) {
        	$scope.saving = true;
            const payload = {code: this.code, newPassword: $scope.form.password.new, passwordConfirmation: $scope.form.password.confirm};

            return $http.post(appConfig.apiUrl + 'password/reset', payload).then(
                (promise) => {
 responder(promise); 
},
                (promise) => {
 responder(promise); 
}
            );
        }
    };
});



// WEBPACK FOOTER //
// ./src/controllers/password.reset.controller.js